import React from 'react'
import HeaderLeftUI from './HeaderLeftUI'
import PublicHeaderRightUI from './PublicHeaderRightUI'
import PublicFooterUI from './PublicFooterUI'
import PageUI from './PageUI'

const PublicPageUI = ({context, className, messageList,
    // header params
    backLink, headerText, headerMessageKey, headerMessageArgs, pageMessageList,
    // content params
    dimension, centered, children,
  }) =>
  <PageUI
    context={context}
    className={className}
    dimension={dimension}
    centered={centered}
    children={children}
    headerLeft={
      <HeaderLeftUI
        context={context}
        backLink={backLink}
        headerText={headerText}
        messageList={messageList}
        headerMessageKey={headerMessageKey}
        headerMessageArgs={headerMessageArgs}
      />
    }
    headerRight={
      <PublicHeaderRightUI context={context} messageList={pageMessageList}
      />
    }
    footer={
      <PublicFooterUI context={context} messageList={pageMessageList} />
    }
  />

export default PublicPageUI
